import axios from 'axios';

export const getBannerImgs = (params) => axios.get('/trip-notify/acc/decorate/special', { params: Object.assign({ servicePlatform: 1, placements: 7 }, params) }).then(response => {
    let data = response.data;
    if (data) {
        data.forEach((item) => {
            item.decorateContent = item.decorateContent.replace('http://', 'https://');
        });
    }
    return response;
});

export const getAnnounces = (params) => axios.get('/trip-notify/acc/announces', { params: Object.assign({ servicePlatform: 1, publishType: 5, page: 1, pageCount: 100 }, params) }).then(response => {
    let data = response.data;
    if (data) {
        data.forEach((item) => {
            if (item.coverPic) {
                item.coverPic = item.coverPic.replace('http://', 'https://');
            }
        });
    }
    return response;
});

export const getTags = (params) => axios.get('/trip-notify/acc/announce/contentTag', { params: Object.assign({ publishType: 5 }, params) });

export const getAnnounceDetail = (id) => axios.get(`/trip-notify/acc/announces/${id}`).then((response) => {
    let data = response.data;
    if (data.contentText) {
        data.contentText = data.contentText.replace(/http:\/\//g, 'https://');
    }
    if (data.coverPic) {
        data.coverPic = data.coverPic.replace('http://', 'https://');
    }
    return response;
});

export const readAnnounnce = (id) => axios.post(`/trip-notify/acc/stcs`, { contentId: id, opType: 1 });

export const getGoodCoursesList = (params) => axios.get(`/trip-notify/acc/announces/courses`, { params: Object.assign({ servicePlatform: 1, page: 1, pageCount: 5 }, params) });


// WEBPACK FOOTER //
// ./src/api/academy.js